import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function ColumnSection() {
  const { columnsData } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{columnsData.label}</p>
              <h2 className="section-title">{columnsData.title}</h2>
              <p className="section-subtitle">{columnsData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {columnsData.items.map((item, idx) => (
              <ScrollReveal key={item.slug} direction="up" delay={idx * 100}>
                <Link to={`/column/${item.slug}`} className="group block">
                  <div className="card-luxury h-full flex flex-col">
                    <div className="aspect-[3/2] overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-6 flex-1 flex flex-col">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-[10px] font-medium tracking-ultra text-airdoa-gold uppercase">
                          {item.category}
                        </span>
                        <span className="text-[10px] text-airdoa-gray">{item.date}</span>
                      </div>
                      <h3 className="text-sm font-serif font-semibold text-airdoa-navy leading-relaxed group-hover:text-airdoa-gold transition-colors duration-300">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-10 text-center">
              <Link to="/column" className="btn-secondary">
                コラム一覧を見る
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}